/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getNurses } from 'app/entities/nurse/nurse.reducer';
import { getEntities as getAdmissions } from 'app/entities/admission/admission.reducer';
import { getEntities as getPressures } from 'app/entities/pressure/pressure.reducer';
import { getEntities as getOtherVitals } from 'app/entities/other-vitals/other-vitals.reducer';
import { getEntities as getVitals } from 'app/entities/vitals/vitals.reducer';
import { createEntity, getEntity, reset, updateEntity } from './nursing-notes.reducer';

export const NursingNotesUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const nurses = useAppSelector(state => state.nurse.entities);
  const admissions = useAppSelector(state => state.admission.entities);
  const pressures = useAppSelector(state => state.pressure.entities);
  const otherVitals = useAppSelector(state => state.otherVitals.entities);
  const vitals = useAppSelector(state => state.vitals.entities);
  const nursingNotesEntity = useAppSelector(state => state.nursingNotes.entity);
  const loading = useAppSelector(state => state.nursingNotes.loading);
  const updating = useAppSelector(state => state.nursingNotes.updating);
  const updateSuccess = useAppSelector(state => state.nursingNotes.updateSuccess);

  const handleClose = () => {
    navigate(`/nursing-notes${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getNurses({}));
    dispatch(getAdmissions({}));
    dispatch(getPressures({}));
    dispatch(getOtherVitals({}));
    dispatch(getVitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.date !== undefined && typeof values.date !== 'number') {
      values.date = Number(values.date);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...nursingNotesEntity,
      ...values,
      nurse: nurses.find(it => it.id.toString() === values.nurse?.toString()),
      admission: admissions.find(it => it.id.toString() === values.admission?.toString()),
      pressure: pressures.find(it => it.id.toString() === values.pressure?.toString()),
      otherVitals: otherVitals.find(it => it.id.toString() === values.otherVitals?.toString()),
      vitals: vitals.find(it => it.id.toString() === values.vitals?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...nursingNotesEntity,
          nurse: nursingNotesEntity?.nurse?.id,
          admission: nursingNotesEntity?.admission?.id,
          pressure: nursingNotesEntity?.pressure?.id,
          otherVitals: nursingNotesEntity?.otherVitals?.id,
          vitals: nursingNotesEntity?.vitals?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.nursingNotes.home.createOrEditLabel" data-cy="NursingNotesCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.nursingNotes.home.createOrEditLabel">Create or edit a NursingNotes</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="nursing-notes-id"
                  label={translate('tinyMedicRestApp.nursingNotes.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.nursingNotes.date')}
                id="nursing-notes-date"
                name="date"
                data-cy="date"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nursingNotes.active')}
                id="nursing-notes-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nursingNotes.timestampentry')}
                id="nursing-notes-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nursingNotes.microSec')}
                id="nursing-notes-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nursingNotes.lastupdated')}
                id="nursing-notes-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nursingNotes.cursor')}
                id="nursing-notes-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.nursingNotes.notes')}
                id="nursing-notes-notes"
                name="notes"
                data-cy="notes"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 500, message: translate('entity.validation.maxlength', { max: 500 }) },
                }}
              />
              <ValidatedField
                id="nursing-notes-nurse"
                name="nurse"
                data-cy="nurse"
                label={translate('tinyMedicRestApp.nursingNotes.nurse')}
                type="select"
                required
              >
                <option value="" key="0" />
                {nurses
                  ? nurses.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="nursing-notes-admission"
                name="admission"
                data-cy="admission"
                label={translate('tinyMedicRestApp.nursingNotes.admission')}
                type="select"
              >
                <option value="" key="0" />
                {admissions
                  ? admissions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="nursing-notes-pressure"
                name="pressure"
                data-cy="pressure"
                label={translate('tinyMedicRestApp.nursingNotes.pressure')}
                type="select"
              >
                <option value="" key="0" />
                {pressures
                  ? pressures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="nursing-notes-otherVitals"
                name="otherVitals"
                data-cy="otherVitals"
                label={translate('tinyMedicRestApp.nursingNotes.otherVitals')}
                type="select"
              >
                <option value="" key="0" />
                {otherVitals
                  ? otherVitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="nursing-notes-vitals"
                name="vitals"
                data-cy="vitals"
                label={translate('tinyMedicRestApp.nursingNotes.vitals')}
                type="select"
              >
                <option value="" key="0" />
                {vitals
                  ? vitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/nursing-notes" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default NursingNotesUpdate;
